export let VALIDATION_CODE_GENERATED = 'validation_code_generated';
export let USER_MSISDN = 'user_msisdn';
export let AUTHENTICATED_MSISDN = 'authenticated_user';
export let SWITCHING_DATA = 'switching_data';

export class SessionService {
    static save(name, value) {
        if (value !== undefined) {
            localStorage.setItem(name, JSON.stringify(value));
        }
    }

    static get(name) {
        let result = localStorage.getItem(name);
        return result ? JSON.parse(result) : undefined;
    }

    static remove(name) {
        localStorage.removeItem(name);
    }

    static clear() {
        localStorage.clear();
    }
}
